/*=========================================================================================
  File Name: moduleSubscriptionMutations.js
  Description: Subscription Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

    SET_SUBSCRIPTION(state, data) {
        state.subscriptionList = data.resultBody
        state.subscriptionCount = data.resultCount
    },
    SET_SUBSCRIPTION_PAYMENT(state, data) {
        state.subscriptionPaymentList = data.resultBody
        state.subscriptionPaymentCount = data.resultCount
    }

}